(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peregy-brand-product-rows"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peregy-brand-product-rows')) {
    customElements.define('peregy-brand-product-rows', class extends HTMLElement {
      connectedCallback() {
        const updateArrows = () => {
          this.querySelectorAll('.peregy-brand-rows__track').forEach((track) => {
            const overflow = track.scrollWidth > track.clientWidth + 2;
            this.querySelectorAll(`[aria-controls="${track.id}"]`).forEach((button) => {
              button.hidden = !overflow;
            });
          });
        };

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-peregy-row-scroll]');
          if (!button || !this.contains(button)) return;
          const track = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
          if (!track) return;
          const rtlMultiplier = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          const direction = button.dataset.peregyRowScroll === 'next' ? 1 : -1;
          track.scrollBy({ left: direction * rtlMultiplier * track.clientWidth * .82, behavior: 'smooth' });
        });

        this.resizeObserver = new ResizeObserver(updateArrows);
        this.querySelectorAll('.peregy-brand-rows__track').forEach((track) => this.resizeObserver.observe(track));
        requestAnimationFrame(updateArrows);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peregy-brand-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBrandStrip = (root) => {
      if (!root || root.dataset.navigationReady === 'true') return;

      const track = root.querySelector('[data-brand-track]');
      const items = Array.from(root.querySelectorAll('[data-brand-item]'));
      const previousButton = root.querySelector('[data-brand-previous]');
      const nextButton = root.querySelector('[data-brand-next]');
      const current = root.querySelector('[data-brand-current]');

      if (!track || items.length < 2 || !previousButton || !nextButton || !current) return;

      root.dataset.navigationReady = 'true';
      let activeIndex = 0;
      let ticking = false;

      const updateNavigation = () => {
        current.textContent = String(activeIndex + 1);
        previousButton.disabled = activeIndex === 0;
        nextButton.disabled = activeIndex === items.length - 1;
      };

      const goToItem = (index) => {
        activeIndex = Math.max(0, Math.min(index, items.length - 1));
        items[activeIndex].scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
        updateNavigation();
      };

      previousButton.addEventListener('click', () => goToItem(activeIndex - 1));
      nextButton.addEventListener('click', () => goToItem(activeIndex + 1));

      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;

        window.requestAnimationFrame(() => {
          const direction = window.getComputedStyle(track).direction;
          const trackBox = track.getBoundingClientRect();
          const trackStart = direction === 'rtl' ? trackBox.right : trackBox.left;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          items.forEach((item, index) => {
            const itemBox = item.getBoundingClientRect();
            const itemStart = direction === 'rtl' ? itemBox.right : itemBox.left;
            const distance = Math.abs(itemStart - trackStart);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          activeIndex = closestIndex;
          updateNavigation();
          ticking = false;
        });
      }, { passive: true });

      updateNavigation();
    };

    document.querySelectorAll('[data-peregy-brand-strip]').forEach(initializeBrandStrip);
    document.addEventListener('shopify:section:load', (event) => {
      initializeBrandStrip(event.target.querySelector('[data-peregy-brand-strip]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peregy-offer-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peregy-offer-countdown')) {
    customElements.define('peregy-offer-countdown', class extends HTMLElement {
      connectedCallback() {
        const timer = this.querySelector('[data-countdown]');
        const deadline = Date.parse(this.dataset.deadline || '');
        if (timer && Number.isFinite(deadline)) {
          const update = () => {
            const distance = Math.max(0, deadline - Date.now());
            const days = Math.floor(distance / 86400000);
            const hours = Math.floor(distance % 86400000 / 3600000);
            const minutes = Math.floor(distance % 3600000 / 60000);
            const seconds = Math.floor(distance % 60000 / 1000);
            timer.querySelector('[data-days]').textContent = String(days).padStart(2, '0');
            timer.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
            timer.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
            timer.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
            if (distance === 0) {
              clearInterval(this.interval);
              timer.replaceChildren(document.createTextNode(this.dataset.expiredLabel || ''));
            }
          };
          update();
          this.interval = setInterval(update, 1000);
        }

        const copyButton = this.querySelector('[data-copy-code]');
        if (copyButton) {
          copyButton.addEventListener('click', async () => {
            try {
              await navigator.clipboard.writeText(this.dataset.code || '');
              this.querySelector('[data-copy-status]').textContent = this.dataset.copiedLabel || '';
            } catch (error) {
              return;
            }
          });
        }
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peregy-product-upsell"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('peregy-product-upsell')) {
    class PeregyProductUpsell extends HTMLElement {
      connectedCallback() {
        const primaryUrl = this.dataset.recommendationsUrl;
        if (!primaryUrl || this.dataset.loadingStarted === 'true') return;
        this.dataset.loadingStarted = 'true';

        const loadMarkup = async (url) => {
          const response = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Recommendations request failed');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          return documentFragment.querySelector('peregy-product-upsell');
        };

        const load = async () => {
          let replacement = await loadMarkup(primaryUrl);
          if (!replacement?.querySelector('.peregy-product-upsell__grid') && this.dataset.fallbackUrl) {
            replacement = await loadMarkup(this.dataset.fallbackUrl);
          }
          if (!replacement?.querySelector('.peregy-product-upsell__grid')) {
            this.hidden = true;
            return;
          }
          this.replaceWith(replacement);
        };

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            load().catch(() => { this.hidden = true; });
          }, { rootMargin: '0px 0px 240px 0px' });
          observer.observe(this);
        } else {
          load().catch(() => { this.hidden = true; });
        }
      }

    }

    customElements.define('peregy-product-upsell', PeregyProductUpsell);
  }

  } catch(e) { console.error(e); }
})();
})();
